// src/components/PatiencePage.js
import React from 'react';
import { Link } from 'react-router-dom';

function PatiencePage() {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-white text-black">
      <div className="text-center">
        <span className="text-9xl">😊</span>
        <h2 className="mt-4 text-4xl font-semibold animate-fadeInUp animate-colorChange neonGlow">
          Please be patient...
        </h2>
      </div>
      <Link to="/" className="mt-8 text-blue-500 underline">
        Return to Home
      </Link>
    </div>
  );
}

export default PatiencePage;
